import React, { Component } from 'react'
import './RequestFormPageHeaderStepbyStep.less'
import parse from 'html-react-parser';
import _ from 'lodash';


export class RequestFormPageHeader extends Component {

    highlightText = (text, textToEmphasize) => {
        var result = text;
        
        if (textToEmphasize && !_.isEmpty(textToEmphasize)) {
            const textCopy = result.toLowerCase();
            textToEmphasize = textToEmphasize.toLowerCase();

            const index = textCopy.indexOf(textToEmphasize);
            
            if(index >= 0){
                const textToEmphasizeExtract = result.substring(index, (index + textToEmphasize.length));
                result = text.replace(textToEmphasizeExtract, `<span class="emphasize more">${textToEmphasizeExtract}</span>`);
            }
        }
        return result;
    }
    render() {
        return (
            <div className="main-header">
                <h1>               
                    {this.props.heading ? parse(this.highlightText(this.props.heading, this.props.highlightText)) : 'Dealgrace Ensures You Get The Best Price by Local Vetted Pros'}
                </h1>
            </div>
        )
    }
}

export default RequestFormPageHeader
